<template>
  <div>
    <template v-if="!errorModels">
      <template v-if="models.length !== 0">
        <div class="models">
          <ModelBox
            v-for="model in models"
            :model="model"
            :key="model.id"
          />
        </div>
      </template>
      <template v-else>
        <div class="no-data">
          {{$t('webstars.empty_following')}}
        </div>
      </template>
    </template>
    <template v-else>
      <p>
        {{$t('error')}}
      </p>
      <button
        type="button"
        @click="loadModels"
      >
        {{$t('retry')}}
      </button>
    </template>
    <Spinner v-if="loadingModels"/>
  </div>
</template>
<script>
import ModelBox from '../components/ModelBox'
import Spinner from '../components/Spinner'
import resources from "../resources";
import EventBus from "../eventbus";

export default {
  name: 'ModelsContainer',
  components: {ModelBox, Spinner},
  props: {
    following: {
      type: Boolean,
      default: false,
    },
    resultsPerPage: {
      type: Number,
      default: 18,
    },
  },
  data(){
    return {
      loadingModels: false,
      models: [],
      errorModels: false,
      error: false,
      currentPage: 1,
      lastLoadedPage: null,
      paginationMeta: {
        total: null,
        total_pages: 3,
        count: null,
        current_page: 0,
      },
    };
  },
  mounted(){
    this.loadModels();
    
    EventBus.$on('languageChanged', () => {
      this.models = [];
      this.currentPage = 1;
      this.loadModels();
    });
    
    EventBus.$on('webstarEndOfScrollPageReached', () => {
      this.loadModels();
    });
  },
  methods: {
    loadModels(){
      if(this.loadingModels || this.paginationMeta.current_page >= this.paginationMeta.total_pages)
          return false;
      
      this.loadingModels = true;
      this.errorModels = false;
  
      let params = {
        per_page: this.resultsPerPage,
        priority: 1,
        page: this.currentPage,
        webstars: true,
        following: this.following
      }
      
      resources.models.index(params)
        .then((response) => {
          this.loadingModels = false;
          this.models = this.models.concat(response.data.data.filter(model => ((this.following) ? model.following : !model.following) ));
          
          // remuevo duplicados
          this.models = this.models.filter((value, index, self) =>
            index === self.findIndex((t) => (
              t.id === value.id
            ))
          )
  
          this.paginationMeta = response.data.meta.pagination;
          if(response.data.data.length === this.resultsPerPage) {
            this.currentPage++;
          }else{
            this.currentPage = null;
          }
        }).catch(err => {
          this.loadingModels = false;
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.models{
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;

  .model{
    flex-grow: 0;
    margin-bottom: 60px;
    flex-basis: 16.6666%;
  
    @media(max-width: 900px){
      flex-basis: 50%;
      margin-bottom: 0;
    }
    
    @media(max-width: 600px){
      flex-basis: 50%;
      margin-bottom: 0;
    }
  }
}

.no-data{
  width: 100%;
  max-width: 1280px;
  margin: 10px auto;
  padding: 25px;
  text-align: center;
  background: #f9f9f9;
  border: 1px dashed #ff0000;
  border-radius: 10px;
}
</style>